import { Component } from '@theme/component';

/**
 * Ticks a days:hours:minutes:seconds countdown down to a target date, then
 * swaps to a "finished" ref once the target has passed.
 *
 * @extends {Component<{digits: HTMLElement, days: HTMLElement, hours: HTMLElement, minutes: HTMLElement, seconds: HTMLElement, finished: HTMLElement}>}
 */
class CountdownTimer extends Component {
  requiredRefs = ['digits', 'days', 'hours', 'minutes', 'seconds', 'finished'];

  /** @type {number} */
  #targetTime = NaN;

  /** @type {number | undefined} */
  #intervalId;

  connectedCallback() {
    super.connectedCallback();

    this.#targetTime = Date.parse(this.getAttribute('target') ?? '');

    if (Number.isNaN(this.#targetTime)) return;

    this.#tick();
    this.#intervalId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearInterval(this.#intervalId);
  }

  #tick() {
    const remainingSeconds = Math.floor((this.#targetTime - Date.now()) / 1000);

    if (remainingSeconds <= 0) {
      window.clearInterval(this.#intervalId);
      this.refs.digits.hidden = true;
      this.refs.finished.hidden = false;
      return;
    }

    this.refs.days.textContent = String(Math.floor(remainingSeconds / 86400)).padStart(2, '0');
    this.refs.hours.textContent = String(Math.floor((remainingSeconds % 86400) / 3600)).padStart(2, '0');
    this.refs.minutes.textContent = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
    this.refs.seconds.textContent = String(remainingSeconds % 60).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
